module.exports = __webpack_public_path__ + "img/SU2F1_new.5f75338d.jpg";